import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { LoaderBlock } from "./styled";
import { Container, Heading, Text } from "../../styled";
import { useDeviceType } from "../../hooks/useDeviceType";
import { greyTextColor, orangeColor, whiteColor } from "../../constants/colors";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import AnimatedDots from "../design_components/AnimatedDots/AnimatedDots";
import { LOADER_ANIMATION_TIME, SE_CLIENT_HEIGHT } from "../../constants/data";

const Loader = ({ data }) => {
  const device = useDeviceType();
  const history = useHistory();
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    stepIncrement();
  }, []);

  const stepIncrement = () => {
    let step = currentStep;

    const next = () => {
      render();
    };

    const render = () => {
      let int = setInterval(() => {
        step++;
        setCurrentStep(step);
        if (step >= data.title.length - 1) {
          clearInterval(int);
          setTimeout(() => {
            history.push(data.nextRoute);
          }, LOADER_ANIMATION_TIME);
        }
      }, LOADER_ANIMATION_TIME);
    };
    next();
  };

  console.log(!!device);

  return (
    <LoaderBlock>
      {!data.needBeImgIndexes.includes(currentStep) ? (
        <LoaderBlock.Img
          style={{
            backgroundImage: `url(${
              !!device
                ? device === "mobile"
                  ? data.bgM[currentStep]
                  : data.bg[currentStep]
                : null
            })`,
            backgroundSize: `${currentStep === 1 ? "100%" : null}`,
          }}
          className={"anim"}
        />
      ) : (
        <LoaderBlock.Img>
          <img
            style={{
              maxWidth: screen.height < SE_CLIENT_HEIGHT ? 295 : 375,
              marginTop: screen.height < SE_CLIENT_HEIGHT ? -45 : 0,
            }}
            src={
              device === "mobile" ? data.bgM[currentStep] : data.bg[currentStep]
            }
            alt=""
          />
        </LoaderBlock.Img>
      )}
      <Container.Content>
        <LoaderBlock.Wrapper>
          <LoaderBlock.Bottom>
            <LoaderBlock.Top className={"anim"} style={{ marginBottom: "5%" }}>
              <Heading.Fourth style={{ color: whiteColor, fontWeight: 600 }}>
                {data.title[currentStep]}
              </Heading.Fourth>
            </LoaderBlock.Top>
            <LoaderBlock.Loader>
              <CircularProgressbar
                value={currentStep + 1}
                strokeWidth={6}
                maxValue={data.title.length - 1}
                styles={buildStyles({
                  pathColor: greyTextColor,
                  trailColor: "#2B2768",
                })}
              />
            </LoaderBlock.Loader>
            <LoaderBlock.Text>
              <Text.Process style={{ color: greyTextColor, fontSize: 18 }}>
                <span>Building Your Plan</span>
                <AnimatedDots />
              </Text.Process>
            </LoaderBlock.Text>
          </LoaderBlock.Bottom>
        </LoaderBlock.Wrapper>
      </Container.Content>
    </LoaderBlock>
  );
};

export default Loader;
